import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _ArrowIosLeft;
import { Fragment } from 'react';
import classNames from 'clsx';
import ArrowIosLeft from '@crehana/compass.icons.outline/ArrowIosLeft';
import { Skeleton } from '@crehana/compass.ui';
import { useStickyState } from '@crehana/react-hooks';
import { AuthUserRoleEnum } from "../../generated/graphql/types";
import useCentralizedOrgSlug from "../../hooks/useCentralizedOrgSlug";
import useCollaboratorTranslations from "../hooks/useMenuLinks/useCollaboratorTranslations";
import { ActionCollapse, Footer, MenuLink } from "./components";
import Header from "./components/Header";
import LinkWithDropdown from "./components/LinkWithDropdown";
import Subtitle from "./components/Subtitle";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SIDEBAR_EXPANDED_WIDTH = '256px';
export var SIDEBAR_COLLAPSED_WIDTH = '112px';
var Sidebar = function Sidebar(_ref) {
  var backToUrl = _ref.backToUrl,
    className = _ref.className,
    organizationSlug = _ref.organizationSlug,
    currentActive = _ref.currentActive,
    footerLinks = _ref.footerLinks,
    fullWidth = _ref.fullWidth,
    header = _ref.header,
    isDark = _ref.isDark,
    _ref$menuLinks = _ref.menuLinks,
    menuLinks = _ref$menuLinks === void 0 ? [] : _ref$menuLinks,
    onClickItem = _ref.onClickItem,
    loadingTalentModules = _ref.loadingTalentModules,
    sidebarType = _ref.sidebarType;
  var _useCollaboratorTrans = useCollaboratorTranslations(),
    t = _useCollaboratorTrans.t;
  var _useCentralizedOrgSlu = useCentralizedOrgSlug({
      organizationSlug: organizationSlug || ''
    }),
    centralizedId = _useCentralizedOrgSlu.centralizedId;
  var userRole = sidebarType === 'admin' ? AuthUserRoleEnum.AuthRoleAdmin : AuthUserRoleEnum.AuthRoleUser;
  var _useStickyState = useStickyState(false, 'homeUserSidebarCollapsed'),
    _useStickyState2 = _slicedToArray(_useStickyState, 2),
    sidebarCollapsed = _useStickyState2[0],
    setSidebarCollapsed = _useStickyState2[1];
  var toggleSideBar = function toggleSideBar() {
    setSidebarCollapsed(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(className, "tw-flex tw-flex-col tw-flex-shrink-0 z-6 tw-relative tw-h-screen sm:tw-h-full tw-border-solid tw-border-[1px] tw-transition-[width] tw-ease-in-out tw-duration-150 ", 'md:tw-h-[calc(100vh-63px)]', isDark ? 'tw-bg-elevation-dark-01 tw-border-elevation-dark-04' : 'tw-bg-neutral-light-100 tw-border-neutral-light-300', {
      'tw-flex-col tw-items-center': sidebarCollapsed,
      'tw-pt-1.6': !backToUrl
    }, {
      'tw-w-full': fullWidth,
      'tw-w-[11.2rem]': !fullWidth && sidebarCollapsed,
      'tw-w-[25.6rem]': !fullWidth && !sidebarCollapsed
    }),
    children: [/*#__PURE__*/_jsx(ActionCollapse, {
      isOpen: !sidebarCollapsed,
      title: sidebarCollapsed ? t('SIDEBAR_EXPAND') : t('SIDEBAR_COLLAPSE'),
      onClick: toggleSideBar
    }), backToUrl && /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: classNames('tw-flex tw-items-center tw-w-full tw-px-1.2 tw-py-1.6 tw-cursor-pointer', {
        'tw-justify-center': sidebarCollapsed
      }),
      onClick: function onClick() {
        if (onClickItem && backToUrl) onClickItem(backToUrl);
      },
      children: [_ArrowIosLeft || (_ArrowIosLeft = /*#__PURE__*/_jsx(ArrowIosLeft, {
        size: 20,
        className: "tw-text-neutral-light-700"
      })), /*#__PURE__*/_jsx("span", {
        className: "tw-font-link1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 ml-4",
        children: sidebarCollapsed ? t('SIDEBAR_BACK') : t('SIDEBAR_BACK_TO_PRODUCTS')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-overflow-y-auto tw-flex-grow",
      children: [header && !sidebarCollapsed && /*#__PURE__*/_jsx(Header, {
        header: header
      }), /*#__PURE__*/_jsx("div", {
        children: loadingTalentModules ? /*#__PURE__*/_jsx("ul", {
          children: /*#__PURE__*/_jsx("li", {
            className: "tw-px-1.2",
            children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (el) {
              return /*#__PURE__*/_jsx(Skeleton, {
                className: "tw-w-full tw-h-4 tw-my-0.8 tw-rounded-0.8"
              }, el);
            })
          })
        }) : /*#__PURE__*/_jsx("ul", {
          className: 'tw-w-ful',
          children: menuLinks.map(function (link) {
            // Renders link with dropdown
            if (link.nested && link.nested.length > 0) {
              return /*#__PURE__*/_jsxs(Fragment, {
                children: [link.subtitle && /*#__PURE__*/_jsx(Subtitle, {
                  text: link.subtitle,
                  sidebarCollapsed: sidebarCollapsed
                }), /*#__PURE__*/_jsx(LinkWithDropdown, {
                  menuLink: link,
                  sidebarCollapsed: sidebarCollapsed,
                  onClickItem: onClickItem,
                  currentActive: currentActive,
                  isDark: !!isDark,
                  centralizedId: centralizedId,
                  userRole: userRole
                })]
              }, link.code + link.label);
            }

            // Render Single link type
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [link.subtitle && /*#__PURE__*/_jsx(Subtitle, {
                text: link.subtitle,
                sidebarCollapsed: sidebarCollapsed
              }), /*#__PURE__*/_jsx(MenuLink, {
                currentActive: currentActive,
                menuLink: link,
                sidebarCollapsed: sidebarCollapsed,
                onClickItem: onClickItem,
                isDark: !!isDark,
                centralizedId: centralizedId,
                userRole: userRole
              })]
            }, link.code + link.label);
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Footer, {
      isDark: isDark,
      organizationSlug: organizationSlug,
      sidebarCollapsed: sidebarCollapsed,
      footerLinks: footerLinks,
      onClickItem: onClickItem,
      isLoading: loadingTalentModules,
      sidebarType: sidebarType
    })]
  });
};
export default Sidebar;